import Lenis from "lenis";
import { header } from "./modules/header";
import { handleFormSubmit } from "./modules/form";
import { triggerModal } from "./modules/modal";
import { initLabel } from "./modules/floatlabel";
import magicLine from "./modules/magicLine";
import preloader from "./modules/preloader";
import { animations } from "./modules/animations";
import { initAccordions } from "./modules/accordions";
import { initPlayer } from "./modules/player";
import { initScrollProgress } from "./modules/scrollProgress";

document.addEventListener("DOMContentLoaded", function () {
  const lenis = new Lenis();

  window.lenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  header().init();
  handleFormSubmit().init();
  triggerModal();
  initLabel();
  magicLine();
  setTimeout(function () {
    animations().init();
  }, 1000);
  initAccordions();
  setTimeout(preloader, 800);
  initPlayer();
  initScrollProgress();

  const formContainer = document.querySelector(".sk-form");
  formContainer.addEventListener("input", function (event) {
    const input = event.target.closest(".js-input");
    if (!input) return;
    const parent = input.closest(".sk-form__field");
    if (input.value.trim() !== "") {
      parent.classList.add("has-content");
    } else {
      parent.classList.remove("has-content");
    }
  });
});

// Hook for Safari
const ua = navigator.userAgent.toLowerCase();
if (ua.indexOf("safari") != -1) {
  if (!(ua.indexOf("chrome") > -1)) {
    document.body.classList.add("safari");
  }
}
